import { useMatch } from 'react-router-dom';
import { useDevice } from '@landr/maestro';
import { Sample } from 'types/generated/graphql';
import { RoutePaths } from 'types/enums';
import { usePartner } from 'hooks/usePartner';

export const useSamplesTableActionsList = ({
    sample,
    biggerThanMobile,
}: {
    biggerThanMobile: boolean;

    sample: Sample;
}) => {
    const isPackDetailsPage = useMatch(`/${RoutePaths.Packs}/:slug`);

    const isCollectionDetailsPage = useMatch(
        `/${RoutePaths.UserCollections}/:slug`,
    );

    const isPartnerDetails =
        useMatch(`/${RoutePaths.Artists}/:slug`) ||
        useMatch(`/${RoutePaths.Labels}/:slug`);

    const partner = usePartner(sample.pack);

    const { isIos } = useDevice();

    const showDownloadButton = !biggerThanMobile && sample;

    return {
        isPackDetailsPage,
        isCollectionDetailsPage,
        isPartnerDetails,
        partner,
        isIos,
        showDownloadButton,
    };
};
